import React from 'react';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter
} from '@/components/ui/dialog';

export const InvoiceDialog = ({ invoice, onClose, onDownloadPdf }) => (
  <Dialog open={!!invoice} onOpenChange={onClose}>
    <DialogContent className="bg-slate-50 border-slate-200 text-slate-900 max-w-lg" data-testid="invoice-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <FileText className="w-5 h-5 text-indigo-700" /> Fatura {invoice?.month}
        </DialogTitle>
        <DialogDescription className="text-slate-500">
          {invoice && <>{invoice.name} · plano <span className="capitalize">{invoice.plan}</span></>}
        </DialogDescription>
      </DialogHeader>
      {invoice && (
        <div className="space-y-2">
          <table className="w-full text-sm">
            <tbody>
              {invoice.line_items.map((li) => (
                <tr key={li.description} className="border-b border-slate-200">
                  <td className="py-2 text-slate-600">{li.description}</td>
                  <td className="py-2 text-right text-slate-700">{li.amount.toFixed(2)}€</td>
                </tr>
              ))}
              <tr>
                <td className="py-2 text-slate-900 font-semibold">Total</td>
                <td className="py-2 text-right text-indigo-700 font-bold" data-testid="invoice-total">{invoice.total.toFixed(2)}€</td>
              </tr>
            </tbody>
          </table>
          <p className="text-xs text-slate-500">Consumo: {invoice.usage.reports_count} denúncias · limite efetivo {invoice.usage.unlimited ? '∞' : invoice.usage.effective_limit} · modo {invoice.usage.overage_mode}</p>
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={() => invoice && onDownloadPdf(invoice.tenant_id)}
          className="border-slate-300 text-slate-700" data-testid="download-invoice-pdf-btn">
          <FileText className="w-4 h-4 mr-2" /> Descarregar PDF
        </Button>
        <Button onClick={onClose} className="bg-indigo-700 hover:bg-amber-600 text-black" data-testid="close-invoice-btn">Fechar</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
